<template>
    <div>
        <div class="flex mt-10 sm:hidden">
            <div>
                <a href="https://play.google.com/store/apps/details?id=au.com.wellful.zutak">
                    <img height="50" src="@/assets/images/google.png" alt="Google Logo" />
                </a>
            </div>
            <div class="customPadding">
                <a href="https://apps.apple.com/au/app/wellful/id1540897708">
                    <img height="50" src="@/assets/images/apple.png" alt="Apple Logo" />
                </a>
            </div>
        </div>
        <div class="mt-10 hidden sm:flex">
            <div>
                <a href="https://play.google.com/store/apps/details?id=au.com.wellful.zutak">
                    <img height="50" src="@/assets/images/google.png" alt="Google Logo" />
                </a>
            </div>
            <div class="customPadding2">
                <a href="https://apps.apple.com/au/app/wellful/id1540897708">
                    <img height="50" src="@/assets/images/apple.png" alt="Apple Logo" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style></style>
